<div class="container-fluid p-0">
    <mat-card class="card mb-3 profile-common-card-container ">
        <form [formGroup]="passwordForm">
            <div class="row mt-3 border-bottom">
                <div class="col-12 mb-3">
                    <div class="col-8">
                        <div class="form-group">
                            <label>{{'Changepassword'|translate}}</label>
                            <p class="normal-text mt-1">{{'ChangepasswordText'|translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12 mt-2 mandatoryTxtLabel">
                    Fields with an asterisk (*) are mandatory
                </div>
                <div class="col-12 mt-3">
                    <div class="col-4 mb-3">
                        <label class="d-block">{{'Currentpassword'|translate}}*</label>
                        <div class="input-icon">
                            <input type="password" class="form-control title-text" formControlName="currentPassword" required autofocus maxlength="30"
                                aria-describedby="emailHelp" [ngClass]="{'is-invalid': submitted && f.currentPassword.errors}">
                            <div *ngIf="submitted && f.currentPassword.errors" class="invalid-feedback">
                                <div *ngIf="f.currentPassword.errors.required">{{'Currentpasswordrequired'|translate}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 mb-3">
                        <label class="d-block">{{'Newpassword'|translate}}*</label>
                        <div class="input-icon">
                            <input class="form-control title-text" maxlength="30" aria-describedby="emailHelp" formControlName="newPassword" required
                                [ngClass]="{'is-invalid': submitted && f.newPassword.errors}" [type]="hide ? 'password' : 'text'">
                            <button class="password-buthide" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                            <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                                <div *ngIf="f.newPassword.errors.required">{{'Newpasswordrequired'|translate}}</div>
                                <div *ngIf="f.newPassword.errors.pattern">
                                    {{ 'Passwordformat' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 mb-3">
                        <label class="d-block">{{'Confirmpassword'|translate}}*</label>
                        <div class="input-icon">
                            <input class="form-control title-text" maxlength="30" aria-describedby="emailHelp" #confirmPasswordModel="ngModel" [(ngModel)]="confirmPasswordVal"
                                [ngModelOptions]="{standalone: true}" (keyup)="showStrengthLable($event.target.value)" required
                                [ngClass]="{ 'is-invalid':  submitted && confirmPasswordModel.invalid }" [type]="hide1 ? 'password' : 'text'">
                            <button class="password-buthide" mat-icon-button matSuffix (click)="hide1 = !hide1" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide1">
                                <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                            <div class="errormsg" *ngIf="submitted && confirmPassword">{{'Confirmnomatch'|translate}}</div>
                            <div *ngIf="submitted && confirmPasswordModel.errors" class="invalid-feedback">
                                <div *ngIf="confirmPasswordModel.errors.required">{{'Confirmpasswordrequired'|translate}}</div>
                            </div>
                            <div class="mt-2">
                                <ng2-password-strength-bar *ngIf="showLableView" [passwordToCheck]="confirmPasswordVal" [strengthLabels]="strengthLabels">
                                </ng2-password-strength-bar>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 mb-3">
                        <p style="line-height:20px;">{{'Changepasswordhint'|translate}}</p>
                    </div>
                </div>
            </div>
        </form>
        <div *ngIf="hideAll">
            <div class="py-3" *ngIf="otpView">
                <mat-divider></mat-divider>
            </div>
            <div class="col-12 m-0 row mt-2" *ngIf="otpView">
                <div class="col-11">
                    <div class="form-group">
                        <label> {{'EnterOnePassword'|translate}}</label>
                        <p>{{'OneTimeEmail'|translate}} {{userInfo?.email}}, {{'PleaseOTPemail'|translate}}</p>
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label> {{'Enter your One Time Password (OTP) here'|translate}}</label>
                        <div class="input-icon mt-2">
                            <input type="text" [(ngModel)]="otpval" maxlength="9" #otpModel="ngModel" [ngClass]="{ 'is-invalid':  otpSubmitted && otpModel.invalid }"
                                class="form-control title-text" autofocus required>
                            <div *ngIf="otpSubmitted && otpModel.errors" class="invalid-feedback">
                                <div *ngIf="otpModel.errors.required">
                                    {{'OTPrequired'|translate}}
                                </div>
                            </div>
                        </div>
                        <p class="float-right mt-1" *ngIf="!showResend">
                            <small> {{'YourequestanotherOTP'|translate}} {{timeLeft}} {{'sec'|translate}}</small>
                        </p>
                        <p class="float-right mt-1 resendCls" *ngIf="showResend" (click)="sendOtp()">
                            <small>{{'Resend OTP'|translate}}</small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-12 mt-4" *ngIf="hideAll">
            <div class="form-group text-left">
                <button *ngIf="submitShow" mat-raised-button color="primary" class="card-header-action" (click)="passwordFun()">{{'Save'|translate}}</button>
                <button *ngIf="!submitShow" mat-raised-button type="submit" color="primary" class="card-header-action" (click)="resend()">{{'Save'|translate}}</button>
            </div>
        </div>
    </mat-card>
</div>